import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FormItem from '../../../components/form/FormItem'
import { MdTitle } from 'react-icons/md'
import { BiX } from 'react-icons/bi'
import { Button, Form } from 'reactstrap'
import { fetchMenuGet } from '../../../redux/slices/menuGetSlice'
import { ToSeoUrl } from '../../../components/general/SeoUrl'
import { fetchMenuCreate } from '../../../redux/slices/menuCreateSlice'
import { fetchMenuUpdate } from '../../../redux/slices/menuUpdateSlice'
import SelectItem from '../../../components/form/SelectItem'
import { fetchMenuGroupGet } from '../../../redux/slices/menuGroupGetSlice'

const CrudMenu = ({ showMenu, setShowMenu, setChanged, setSelectedItem, lang, id, selectedItem, t }) => {
    const [formData, setFormData] = useState({ files: [], parentMenuId: 0, menuGroupId: id, sort: 0 })
    const [options, setOptions] = useState([])
    const dispatch = useDispatch()

    const getData = async () => {
        console.log('getData çağrıldı, selectedItem:', selectedItem);
        var menuList = []
        var menuGroup = await dispatch(fetchMenuGroupGet({ id: id }))
        console.log('menuGroup:', menuGroup.payload);

        if (menuGroup.payload) {
            menuGroup.payload?.menus?.forEach(item => {
                menuList.push({ value: item.id, label: item.title[lang] })
            });
            console.log('menuList options:', menuList);
            setOptions(menuList)
        }

        if (selectedItem !== 0) {
            console.log('Menü alınıyor, id:', selectedItem);
            var data = await dispatch(fetchMenuGet({ id: selectedItem }))
            console.log('Alınan menü bilgileri:', data.payload);

            if (data.payload) {
                setFormData({
                    files: data.payload?.files,
                    titletr: data.payload?.title["tr"],
                    titleen: data.payload?.title["en"],
                    slugtr: data.payload?.slug["tr"],
                    slugen: data.payload?.slug["en"],
                    parentMenuId: data.payload?.parentMenuId,
                    menuGroupId: id,
                    sort: data.payload?.sort || 0,
                })
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const title = { "tr": formData.titletr, "en": formData.titleen }
        const slug = { "tr": formData.slugtr, "en": formData.slugen }

        const filesToKeep = formData.files
            .filter(file => typeof file === 'string' || !file.file)
            .map(file => typeof file === 'string' ? file : file.preview);

        const newFiles = formData.files.filter(file => file.file);

        await dispatch(
            selectedItem === 0 ?
                fetchMenuCreate({ file: newFiles, title: title, slug: slug, menuGroupId: id, sort: formData.sort }) :
                fetchMenuUpdate({ id: selectedItem, filesToKeep: filesToKeep, file: newFiles, title: title, slug: slug, menuGroupId: id, sort: formData.sort })
        )
        setChanged(true)
        setFormData({ files: [] })
        getData()
        setShowMenu(false)
    }

    const closeModal = () => {
        setFormData({ files: [], titletr: "", titleen: "" })
        setShowMenu(false)
        setSelectedItem(0)
    }

    useEffect(() => { getData() }, [dispatch, selectedItem, id, lang])

    return (
        <div className={showMenu ? 'right-popup' : 'd-none'}>
            <div className='right-popup-close' onClick={closeModal}><BiX size={24} /></div>
            <div className='right-popup-menu'>
                <div className='mb-3 text-center'><h5>{t(selectedItem === 0 ? "add_menu" : "edit_menu")}</h5></div>
                <Form onSubmit={handleSubmit}>
                    <FormItem
                        id={`titletr`}
                        name={`titletr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titletr'
                        onChange={() => setFormData(prev => ({ ...prev, slugtr: ToSeoUrl(prev.titletr) }))}
                    />
                    <FormItem
                        id={`slugtr`}
                        name={`slugtr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("slug")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='slugtr'
                    />
                    <FormItem
                        id={`titleen`}
                        name={`titleen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titleen'
                        onChange={() => setFormData(prev => ({ ...prev, slugen: ToSeoUrl(prev.titleen) }))}
                    />
                    <FormItem
                        id={`slugen`}
                        name={`slugen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("slug")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='slugen'
                    />
                    <SelectItem
                        title={t("related_menu")}
                        formData={formData}
                        setFormData={setFormData}
                        options={options}
                        value={formData.parentMenuId}
                    />

                    <div className='d-flex justify-content-end mt-4 w-100'>
                        <Button type='submit' color={selectedItem === 0 ? 'primary' : 'warning'} className="text-white">
                            {t(selectedItem === 0 ? "add" : "edit")}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CrudMenu